import { useState } from "react"
import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorTriggerProps } from "@/v2-backoffice-client/components/selector"
import { useLayerCategoryQuery } from "@/v2-backoffice-client/layer/category/layer.category.query"
import LayerCategoryLayerAddManySelectorItem from "@/v2-backoffice-client/layer/category/layer/add/many/LayerCategoryLayerAddManySelectorItem"

export type LayerCategoryLayerAddManySelectorProps = SelectorTriggerProps & {
  layerFeatureCodes: string[]
  existingCategoryCodes?: string[]
}

function LayerCategoryLayerAddManySelector(
  props: LayerCategoryLayerAddManySelectorProps,
) {
  const {
    layerFeatureCodes,
    existingCategoryCodes = [],
    ...triggerProps
  } = props

  const [addedCodes, setAddedCodes] = useState<Set<string>>(new Set())

  const { data, loading, error } = useLayerCategoryQuery()
  errorToast(error, {
    title: "Failed to query for categories",
  })

  const categories = data?.getLayerCategories ?? []

  return (
    <Selector
      shouldFilter
      onOpenChange={(open) => {
        if (!open) setAddedCodes(new Set())
      }}
    >
      <Selector.Trigger iconSrc="layers" {...triggerProps}>
        {triggerProps.children ?? "Add to Category"}
      </Selector.Trigger>

      <Selector.Content>
        <Selector.Search placeholder="Search categories..." debounce={0} />
        <Selector.List
          emptyLabel="No categories found"
          isLoading={loading}
          error={error}
        >
          {categories.map((cat) => (
            <LayerCategoryLayerAddManySelectorItem
              key={cat.FeatureCode}
              category={cat}
              layerFeatureCodes={layerFeatureCodes}
              added={
                existingCategoryCodes.includes(cat.FeatureCode) ||
                addedCodes.has(cat.FeatureCode)
              }
              onSelect={() => {
                setAddedCodes((prev) => new Set(prev).add(cat.FeatureCode))
              }}
            />
          ))}
        </Selector.List>
      </Selector.Content>
    </Selector>
  )
}

export default LayerCategoryLayerAddManySelector
